import React, {useEffect, useRef} from 'react';
import {Animated, Easing, Platform, Text} from 'react-native';

import {styles} from './LoadingBox.style';
interface LoadingBoxProps {
  style: Object;
  testID: string;
}

export const LoadingBox: React.FC<LoadingBoxProps> = ({
  style = {},
  testID = '',
}) => {
  const opacity = useRef(new Animated.Value(0.3)).current;

  const animatedStyles = [styles.base, style, {opacity}];

  useEffect(
    () => {
      Animated.loop(
        Animated.sequence([
          Animated.timing(opacity, {
            toValue: 0.9,
            duration: 700,
            easing: Easing.linear,
            useNativeDriver: true,
          }),
          Animated.timing(opacity, {
            toValue: 0.3,
            duration: 700,
            easing: Easing.linear,
            useNativeDriver: true,
          }),
        ]),
        {
          iterations: -1,
        },
      ).start();
    },
    // The animation should only start on initial render as it loops continuously
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return (
    <Animated.View style={animatedStyles} testID={testID}>
      {Platform.OS == 'web' && <Text> </Text>}
    </Animated.View>
  );
};
